import {Pipe, PipeTransform}   from '@angular/core';
import {filter, includes, map} from 'lodash';
import {CropTypeStore}         from '../../stores/base-data/crop.types.store';
import IFieldCropRotation = Data.FieldManagement.IFieldCropRotation;

/**
 * get the Childes MainCrop Short Name`s as a Comma separated String
 */
@Pipe({
  name: 'getMappedChildren'
})
export class GetMappedChildrenPipe implements PipeTransform {
  constructor(private cropTypeStateService: CropTypeStore) {
  }

  transform(value: IFieldCropRotation, args?: number): string {
    const cropTypeIds = map(filter(value.Children, (i) => i.Yields[0].MainCrop), i => i.Yields[0].MainCrop);
    if (cropTypeIds.length < 1) {
      return '';
    }
    const store = [];
    for (const cropTypeId of cropTypeIds) {
      const crop = this.cropTypeStateService.getDefaultCroptype(cropTypeId);
      if (!crop) {
        console.warn(`CropKey ${cropTypeId} not found`);
        continue;
      }
      if (includes(store, crop.Shortname)) {
        continue;
      }
      store.push(crop.Shortname);
    }
    return store.join(',');
  }

}
